module.exports = __webpack_public_path__ + "static/img/14001002.ea9ca68a.png";